import React from 'react';
import { linkFields } from '@/forms/state/state';
import RequestObjectInputs from './RequestObjectInputs';

const RequestLinkList = ({
  category,
  code,
  field,
  section,
}) => (
  <RequestObjectInputs
    category={category}
    code={code}
    field={field}
    fields={linkFields(field)}
    section={section}
  />
);

export default RequestLinkList;
